// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react: true*/
import zutil from 'zutil';

export class Model {
    event_listeners: object_of<(()=>void)[]> = {};
    attributes: object_of<any> = {};
    constructor(props?:object_of<any>){
        if (!props)
            return;
        const keys = Object.keys(props);
        keys.forEach(k=>{
            this[k] = props[k];
        });
    }
    on = (event_name: string, fn)=>{
        const events = event_name.split(' ');
        events.forEach(event=>{
            if (!this.event_listeners[event])
                this.event_listeners[event] = [];
            this.event_listeners[event].push(fn);
        });
        return ()=>{
            const events_ = event_name.split(' ');
            events_.forEach(event=>{
                const index = this.event_listeners[event]?.indexOf(fn);
                if (index!==undefined && index>-1)
                    this.event_listeners[event]?.splice(index, 1);
            });
        };
    };
    has_event_listener = (event_name: string)=>{
        const events = event_name.split(' ');
        events.forEach(event=>{
            if (this.event_listeners[event]
                && this.event_listeners[event].length>0)
            {
                return true;
            }
        });
        return false;
    };
    off = ()=>{
        // XXX dmitriiz:
        // we don't use this, therefore it's not implemented at all
        // only one place - for clear all listeners
        // for unsubscribe use function returned from ON
        this.event_listeners = {};
    };
    get = (path:string)=>{
        return this.attributes[path] || zutil.get(this.attributes, path);
    };
    set = (path: string, value: any)=>{
        this.attributes[path] = value;
        const event_for_fire = `change:${path}`;
        this.notify(event_for_fire);
    };
    unset = (path:string)=>{
        delete this.attributes[path];
    };
    notify = (event_for_fire:string)=>{
        const list_of_events = this.event_listeners[event_for_fire];
        if (!list_of_events)
            return;
        list_of_events.forEach(fn=>fn());
    };
}
